var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h3", { staticClass: "text-center mb-6" }, [
      _vm._v(_vm._s(_vm.$t("roomWizard.insertCode")))
    ]),
    _c("div", { staticClass: "d-flex justify-md-space-around my-8" }, [
      _c(
        "div",
        [
          _c("v-otp-input", {
            staticStyle: { width: "30vw" },
            attrs: { disabled: _vm.loading },
            on: { input: _vm.onInput },
            model: {
              value: _vm.code,
              callback: function($$v) {
                _vm.code = $$v
              },
              expression: "code"
            }
          })
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "d-flex justify-space-between my-8" },
      [
        !_vm.first
          ? _c("va-button", {
              staticClass: "mr-4",
              attrs: {
                color: "secondary",
                type: "outline",
                cta: _vm.$t("roomWizard.prev")
              },
              on: { click: _vm.onBack }
            })
          : _c("v-spacer"),
        _c("va-button", {
          attrs: {
            disabled: _vm.code.length !== 6,
            loading: _vm.loading,
            cta: _vm.$t("roomWizard.next")
          },
          on: { click: _vm.connectToRoom }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }